import { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { urlDocument } from '../services/api';

/**
 * Relais des liens de facture et de note de crédit envoyés par e-mail.
 *
 * L'e-mail de confirmation pointe vers le site (mirumgames.com/facture/…),
 * parce que le backend ne connaît pas sa propre adresse publique ; le site,
 * lui, la connaît (VITE_API_URL). On renvoie donc tel quel vers l'API, clé
 * signée comprise : c'est l'API qui vérifie la clé et sert le document.
 */
export default function DocumentComptable({ type }) {
  const { numero } = useParams();
  const { search } = useLocation();

  useEffect(() => {
    window.location.replace(urlDocument(`/${type}/${encodeURIComponent(numero)}${search}`));
  }, [type, numero, search]);

  return null;
}
